import { render, staticRenderFns } from "./addStation.vue?vue&type=template&id=1588d40a&scoped=true"
import script from "./addStation.vue?vue&type=script&lang=js"
export * from "./addStation.vue?vue&type=script&lang=js"
import style0 from "./addStation.vue?vue&type=style&index=0&id=1588d40a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1588d40a",
  null
  
)

export default component.exports